export default {
  namespace: 'ContentHub',
  translations: {
    zh: {
      news: {
        hero: {
          kicker: 'NEWS CENTER',
          title: '新闻中心',
          description: '聚合平台动态、产品进展与生态合作资讯，持续呈现 Future World 的最新内容与关键信息。',
        },
        filters: {
          policy: '各国政策',
          events: '近期事件',
          seminars: '研讨会',
          hrGuide: '出海 HR 宝典',
        },
      },
      resources: {
        hero: {
          kicker: 'RESOURCE CENTER',
          title: '资源中心',
          description: '围绕人才库、专家库与服务案例库，集中呈现可检索、可沉淀的核心资源内容。',
        },
      },
      common: {
        readMore: '查看详情',
        backToNews: '返回新闻中心',
        backToResources: '返回资源中心',
        publishedOn: '发布时间',
        prev: '上一页',
        next: '下一页',
        loading: '内容加载中...',
        backendUnavailable: '内容服务暂时不可用，请稍后再试。',
        noData: '暂时未发布内容',
        notFoundTitle: '内容暂未发布',
        notFoundDescription: '当前语言下暂时没有这篇内容，可能尚未发布或已下线。',
        categoryTalent: '人才库',
        categoryExperts: '专家库',
        categoryCases: '服务案例库',
      },
    },
    en: {
      news: {
        hero: {
          kicker: 'NEWS CENTER',
          title: 'News Center',
          description: 'A central space for platform updates, product progress, and ecosystem stories from Future World.',
        },
        filters: {
          policy: 'Policies',
          events: 'Recent Events',
          seminars: 'Seminars',
          hrGuide: 'Global HR Guide',
        },
      },
      resources: {
        hero: {
          kicker: 'RESOURCE CENTER',
          title: 'Resource Center',
          description: 'A structured resource center for the talent pool, expert network, and service case library.',
        },
      },
      common: {
        readMore: 'View Details',
        backToNews: 'Back to News Center',
        backToResources: 'Back to Resource Center',
        publishedOn: 'Published on',
        prev: 'Previous',
        next: 'Next',
        loading: 'Loading content...',
        backendUnavailable: 'The content service is temporarily unavailable. Please try again later.',
        noData: 'No published content yet',
        notFoundTitle: 'Content Not Published',
        notFoundDescription: 'This content is not available in the current language yet, or it has been unpublished.',
        categoryTalent: 'Talent Pool',
        categoryExperts: 'Expert Pool',
        categoryCases: 'Service Case Library',
      },
    },
    ja: {
      news: {
        hero: {
          kicker: 'NEWS CENTER',
          title: 'ニュースセンター',
          description: 'Future World の最新動向、プロダクト進捗、提携情報をまとめてお届けします。',
        },
        filters: {
          policy: '各国政策',
          events: '最近の出来事',
          seminars: 'セミナー',
          hrGuide: '海外 HR ガイド',
        },
      },
      resources: {
        hero: {
          kicker: 'RESOURCE CENTER',
          title: 'リソースセンター',
          description: '人材、専門家、サービス事例に関する主要リソースをまとめて確認できます。',
        },
      },
      common: {
        readMore: '詳細を見る',
        backToNews: 'ニュースセンターへ戻る',
        backToResources: 'リソースセンターへ戻る',
        publishedOn: '公開日',
        prev: '前へ',
        next: '次へ',
        loading: 'コンテンツを読み込み中...',
        backendUnavailable: 'コンテンツサービスは一時的に利用できません。しばらくしてからお試しください。',
        noData: '公開中のコンテンツはまだありません',
        notFoundTitle: 'コンテンツは未公開です',
        notFoundDescription: '現在の言語ではまだ公開されていないか、公開終了している可能性があります。',
        categoryTalent: '人材データベース',
        categoryExperts: '専門家ネットワーク',
        categoryCases: 'サービス事例集',
      },
    },
  },
};